export enum AccessLevel {
  PUBLIC = 'Public',
  AUTHENTICATED = 'Authenticated Only',
  VERIFIED = 'Verified Only',
  CSR = 'CSR Only'
}
